import { Injectable } from '@angular/core';
import { GungAnonymousConfigService } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class SjoborgAnonymousConfigService extends GungAnonymousConfigService {

  public showAnonymousAvailabilities: boolean = true;
}
